
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legends/[slug]",
      function () {
        return require("private-next-pages/legends/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legends/[slug]"])
      });
    }
  